import { Icon, Icons } from '@silverfort/sf-components';
import React, { FC } from 'react';
import { SEVERITIES_INFO } from '../../../../../consts/Severity';
import { RISK_LEVELS } from '@silverfort-nodelibs/common/utils/consts';

interface Props {
    riskLevel?: number;
}

const RiskLevelColumn: FC<Props> = ({ riskLevel }) => {
    return (
        <div className="h-6 w-fit max-w-20 px-2 flex items-center gap-1 border rounded">
            <Icon
                icon={Icons.Warning}
                className={`text-${SEVERITIES_INFO[riskLevel ?? RISK_LEVELS.LOW.value].color}`}
                size={16}
            />
            <div className="text-12 text-sf-gray-800 font-sf">
                {SEVERITIES_INFO[riskLevel ?? RISK_LEVELS.LOW.value].label}
            </div>
        </div>
    );
};

export default RiskLevelColumn;
